import { Mutex } from 'async-mutex';

export const mutex = new Mutex();
